<template>
  <v-chip
    ref="zoox-chip"
    tabindex="0"
    class="zoox-component zoox-chip"
    label
    close-icon="$close_rounded"
    :class="chipClasses"
    :dark="dark"
    :color="appliedColor"
    :disabled="disabled"
    :value="selected"
    v-bind="$attrs"
    v-on="$listeners"
    @click="onClickChip"
  >
    <slot name="prepend-inner"></slot>

    <z-icon
      v-if="iconLeft && !iconRight && icon !== null"
      left
      class="mr-1"
      :size="iconSize"
      :class="{'body-3': small}"
      :color="appliedIconColor"
      @click.native.stop="onClickIcon"
    >
      {{ icon }}
    </z-icon>

    <span
      class="zoox-chip-text"
      :class="{small, 'x-small': xSmall}"
      :style="{color: selected ? $zoox.colors.white : appliedColor}"
    >
      {{ text }}
    </span>

    <z-icon
      v-if="iconRight && icon !== null"
      right
      class="ml-1"
      :size="iconSize"
      :class="{'body-3': small}"
      :color="appliedIconColor"
      @click.native.stop="onClickIcon"
      >{{ icon }}</z-icon
    >

    <slot name="append-inner"></slot>
  </v-chip>
</template>

<script>
import chipsMixin from '../chipsMixin'

/**
 * Representa uma ação relacionada a algum conteúdo previamente apresentado.
 * @displayName Chip
 */
export default {
  name: 'ZChip',
  mixins: [chipsMixin],
  model: {
    prop: 'selected',
    event: 'change',
  },
  props: {
    /**
     * Define a posição do ícone á esquerda do chip.
     */
    iconLeft: {
      type: Boolean,
      default: true,
    },

    /**
     * Define a posição do ícone á direita do chip.
     */
    iconRight: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClickChip() {
      /**
       * Evento emitido ao clicar no chip e ocorre mudando no estado do componente.
       *
       * @property {Boolean} selected - Estado do componente.
       */
      this.$emit('change', !this.selected)
    },

    onClickIcon(e) {
      if ('click:icon' in this.$listeners) {
        this.$emit('click:icon', e)
      } else {
        this.$emit('click', e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@scss/chips' as c;

.zoox-chip {
  @include c.zoox-chip-base;
}
</style>
